module.exports = __webpack_public_path__ + "img/nbus_box_3.1917e81a.jpg";